import {action, makeAutoObservable, runInAction} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import Article from "../../../entities/Article";
import {ArticleService} from "../../../service/articleDelivery/ArticleService";
import {ArticleStockService} from "../../../service/articleDelivery/ArticleStockService";
import Pagination from "../../../entities/Pagination";
import ArticleStockResponse from "../../../model/articleDelivery/ArticleStockResponse";

class ArticleStockStore {

    public articleId: string;
    public article: Article;
    public isModalOpen: boolean;
    public loading: boolean;
    public phoneError?: string;
    public nameError?: string;
    public commonStore: CommonStore;
    public pagination: Pagination;
    public filter?: string;
    public articleStocks: ArticleStockResponse[];
    public assignedArticleStockAmount: number;

    constructor(commonStore: CommonStore, articleId?: string) {
        this.articleId = articleId ?? '';
        this.isModalOpen = false;
        this.article = {} as Article;
        this.loading = false;
        this.commonStore = commonStore;
        this.pagination = new Pagination(1, 15, 0, 0);
        this.articleStocks = [];
        this.assignedArticleStockAmount = 0;
        makeAutoObservable(this);
    }

    get enableButton(): boolean {
        return !!(this.article?.name);
    }

    @action
    public async loadArticle() {
        const response = await ArticleService.find(this.articleId!)
        if (response.success && response.data) {
            this.article = response.data;
        }
        this.commonStore.processErrors(response);

        // Load stock details
        const responseStock = await ArticleStockService.getAssignedArticleStockAmount(this.articleId!)
        if (responseStock.success) {
            this.assignedArticleStockAmount = responseStock.data ?? 0;
        }
        this.commonStore.processErrors(response);
    }

    @action
    public async getStock(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        this.commonStore.setLoading();
        const response = await ArticleStockService.get(page, pageSize, this.articleId);
        if (response.success) {
            runInAction(() => {
                this.articleStocks = response.data?.data || [];
                this.pagination = response.data?.pagination || this.pagination;
            })
        }
        this.commonStore.processErrors(response);
        this.commonStore.removeLoading();
    }

    @action
    public async openModal() {
        this.isModalOpen = true;
        this.loading = true;
        await this.loadArticle();
        await this.search();
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    get isEmpty(): boolean {
        return this.articleStocks.length === 0;
    }

    public setFilter(filer: string) {
        this.filter = filer;
    }

    @action
    public async goToPage(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        await this.getStock(page, pageSize);
    }

    @action
    public async search() {
        await this.getStock(1);
    }

}

export default ArticleStockStore;